import { withNamespace } from '../helper';

const namespace = '@PRODUCT';

export const GET_ALL = withNamespace('GET_ALL', namespace);
export const GET_ALL_SUCCESS = withNamespace('GET_ALL_SUCCESS', namespace);

export const GET_DETAIL = withNamespace('GET_DETAIL', namespace);
export const GET_DETAIL_SUCCESS = withNamespace('GET_DETAIL_SUCCESS', namespace);

export const DELETE = withNamespace('DELETE', namespace);
export const DELETE_SUCCESS = withNamespace('DELETE_SUCCESS', namespace);

export const UPDATE = withNamespace('UPDATE', namespace);
export const UPDATE_SUCCESS = withNamespace('UPDATE_SUCCESS', namespace);

export const CREATE = withNamespace('CREATE', namespace);
export const CREATE_SUCCESS = withNamespace('CREATE_SUCCESS', namespace);

export const DELETE_SKU = withNamespace('DELETE_SKU', namespace);
export const DELETE_SKU_SUCCESS = withNamespace('DELETE_SKU_SUCCESS', namespace);

export const DEACTIVATE_PRODUCT = withNamespace('DEACTIVATE_PRODUCT', namespace);
export const DEACTIVATE_PRODUCT_SUCCESS = withNamespace('DEACTIVATE_PRODUCT_SUCCESS', namespace);

export const UPDATE_SKU = withNamespace('UPDATE_SKU', namespace);
export const UPDATE_SKU_SUCCESS = withNamespace('UPDATE_SKU_SUCCESS', namespace);

export const UPDATE_SKU_FILES = withNamespace('UPDATE_SKU_FILES', namespace);
export const UPDATE_SKU_FILES_SUCCESS = withNamespace('UPDATE_SKU_FILES_SUCCESS', namespace);

export const CREATE_SKU_IDENTIFIER = withNamespace('CREATE_SKU_IDENTIFIER', namespace);
export const CREATE_SKU_IDENTIFIER_SUCCESS = withNamespace(
  'CREATE_SKU_IDENTIFIER_SUCCESS',
  namespace,
);

export const REMOVE_SKU_IDENTIFIER = withNamespace('REMOVE_SKU_IDENTIFIER', namespace);
export const REMOVE_SKU_IDENTIFIER_SUCCESS = withNamespace(
  'REMOVE_SKU_IDENTIFIER_SUCCESS',
  namespace,
);

export const UPDATE_SKU_IDENTIFIER = withNamespace('UPDATE_SKU_IDENTIFIER', namespace);
export const UPDATE_SKU_IDENTIFIER_SUCCESS = withNamespace(
  'UPDATE_SKU_IDENTIFIER_SUCCESS',
  namespace,
);

export const CREATE_SKU = withNamespace('CREATE_SKU', namespace);
export const CREATE_SKU_SUCCESS = withNamespace('CREATE_SKU_SUCCESS', namespace);

export const DELETE_SKU_FILE = withNamespace('DELETE_SKU_FILE', namespace);
export const DELETE_SKU_FILE_SUCCESS = withNamespace('DELETE_SKU_FILE_SUCCESS', namespace);

export const CREATE_SKU_FILE = withNamespace('CREATE_SKU_FILE', namespace);
export const CREATE_SKU_FILE_SUCCESS = withNamespace('CREATE_SKU_FILE_SUCCESS', namespace);

export const SORTABLE = withNamespace('SORTABLE', namespace);
export const REQUEST_ERROR = withNamespace('REQUEST_ERROR', namespace);
export const SORTABLE_SKU = withNamespace('SORTABLE_SKU', namespace);

export const GET_INTEGRATION = withNamespace('GET_INTEGRATION', namespace);
export const GET_INTEGRATION_SUCCESS = withNamespace('GET_INTEGRATION_SUCCESS', namespace);

export const GET_BUSINESSES = withNamespace('GET_BUSINESSES', namespace);
export const GET_BUSINESSES_SUCCESS = withNamespace('GET_BUSINESSES_SUCCESS', namespace);

export const GET_PRODUCT_TYPES = withNamespace('GET_PRODUCT_TYPES', namespace);
export const GET_PRODUCT_TYPES_SUCCESS = withNamespace('GET_PRODUCT_TYPES_SUCCESS', namespace);

export const GET_PRODUCT_SKU_FILE_SUB_TYPES = withNamespace(
  'GET_PRODUCT_SKU_FILE_SUB_TYPES',
  namespace,
);
export const GET_PRODUCT_SKU_FILE_SUB_TYPES_SUCCESS = withNamespace(
  'GET_PRODUCT_SKU_FILE_SUB_TYPES_SUCCESS',
  namespace,
);

export const GET_PRODUCT_PACK_TYPE = withNamespace('GET_PRODUCT_PACK_TYPE', namespace);
export const GET_PRODUCT_PACK_TYPE_SUCCESS = withNamespace('GET_PRODUCT_PACK_TYPE_SUCCESS', namespace);

export const CREATE_SKU_TAG = withNamespace('CREATE_SKU_TAG', namespace);
export const CREATE_SKU_TAG_SUCCESS = withNamespace('CREATE_SKU_TAG_SUCCESS', namespace);

export const UPDATE_SKU_TAG = withNamespace('UPDATE_SKU_TAG', namespace);
export const UPDATE_SKU_TAG_SUCCESS = withNamespace('UPDATE_SKU_TAG_SUCCESS', namespace);

export const DELETE_SKU_TAG = withNamespace('DELETE_SKU_TAG', namespace);
export const DELETE_SKU_TAG_SUCCESS = withNamespace('DELETE_SKU_TAG_SUCCESS', namespace);
